import { getOutOfStockModifications } from '../../helpers';
import { type Guard } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Determines whether there are any out-of-stock modifications present.
 */
export const checkIfHasOutOfStockModifications: Guard = function (
  args,
): boolean {
  const { context } = args;

  const { modifications } = context;

  // ─── Missing Data ────────────────────────────────────────────────────

  const hasMissingData = !modifications;

  if (hasMissingData) {
    return false;
  }

  // ─────────────────────────────────────────────────────────────────────

  const { initial } = modifications;
  const outOfStockModifications = getOutOfStockModifications(initial);

  return outOfStockModifications.length > 0;
};
